import React from 'react';
import { Link } from 'react-router-dom';

function Branding() {
  return (
    <div className="docs-content">
      <h1>Branding</h1>
      <p className="docs-lead">
        Admins and Super Admins can customize how SignTada looks for their organization: product name, logo, primary and accent colors, and theme. The dashboard and signing experience can reflect your brand.
      </p>

      <h2>Where to configure</h2>
      <p>
        Branding is managed under <strong>Settings</strong> in the dashboard. Admins configure branding for their company; Super Admins can switch to a company in the top bar and set branding per company. Changes apply to the dashboard and, where supported, to the signing and verification pages (e.g. logo, colors, product name).
      </p>

      <h2>What you can customize</h2>
      <ul>
        <li><strong>Product name</strong> — The name shown in the app (e.g. “SignTada” or your own product name).</li>
        <li><strong>Logo</strong> — Your organization’s logo, displayed in the dashboard and optionally on signing pages.</li>
        <li><strong>Primary and accent colors</strong> — Buttons, links, and highlights use these colors so the UI matches your brand.</li>
        <li><strong>Theme</strong> — Choose from preset themes (e.g. default, Ocean) for the dashboard. The theme you set here applies only to the dashboard; the <strong>Documentation</strong> tab always uses the default yellow-and-black theme and is not affected by dashboard settings.</li>
      </ul>

      <h2>API</h2>
      <p>
        The <Link to="/api-reference/branding">Branding API</Link> allows you to get and update branding programmatically (Admin/Super Admin). A public endpoint returns branding for a given organization (e.g. for embedding in the signing page) without authentication. See the API Reference for request and response formats.
      </p>

      <p>
        <Link to="/verification">← Document Verification</Link> · <Link to="/api-keys">API Keys →</Link>
      </p>
    </div>
  );
}

export default Branding;
